import type { SyncState } from "../types";

export type DisplayState =
  | "local"
  | "synced"
  | "pending"
  | "offline"
  | "syncing"
  | "conflict"
  | "error";

/**
 * Determine the sync indicator display state from current conditions.
 * Pure function — extracted for testability.
 *
 * `local` (notes on this device only, no account) wins over everything:
 * it is not a problem state, so it must never surface as amber/pending —
 * queued ops are simply how local mode stores future backup payloads.
 */
export function getSyncDisplayState(opts: {
  isOnline: boolean;
  syncState: SyncState;
  pendingCount: number;
  conflictCount: number;
  localMode?: boolean;
}): DisplayState {
  if (opts.localMode) return "local";
  if (opts.conflictCount > 0) return "conflict";
  if (!opts.isOnline) return "offline";
  if (opts.syncState === "syncing") return "syncing";
  if (opts.syncState === "error") return "error";
  if (opts.pendingCount > 0) return "pending";
  return "synced";
}
